import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/globals.css';

const container = document.getElementById('root');
if (container === null) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The inline splash in index.html is what the learner sees while all of this
// downloads. Taking it away on the commit callback rather than on a timer
// means it is still there for the frame the first screen paints in, so there
// is no white flash between the two.
const splash = document.getElementById('splash');
if (splash !== null) {
  requestAnimationFrame(() => {
    splash.remove();
  });
}
